import { Component, OnInit } from '@angular/core';
import { faTwitter , faInstagram, faGithub, faLinkedin} from '@fortawesome/free-brands-svg-icons';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.css']
})
export class FooterComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

  tw = faTwitter;
  git = faGithub;
  in = faInstagram;
  ln = faLinkedin;

}
